import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import Loader from '../../ApiCheck/Loader'
import { baseUrl } from '../../ApiCheck/Constant';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(1); 
  const [loading, setLoading] = useState(false); 
  const navigate = useNavigate();

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 
    try {
      await axios.post(`${baseUrl}/api/otp`, { email });
      toast.success('OTP sent to your email.', { position: 'top-center', autoClose: 3000 });
      setStep(2); 
    } catch (error) {
      toast.error(error?.response?.data?.message, { position: 'top-center', autoClose: 3000 });
    } finally {
      setLoading(false); 
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 
    try {
      await axios.post(`${baseUrl}/api/verify-otp`, { email, otp, newPassword });
      toast.success('Password reset successful!', { position: 'top-center', autoClose: 3000 });
      navigate('/login');
    } catch (error) {
      toast.error(error?.response?.data?.message, { position: 'top-center', autoClose: 3000 });
    } finally {
      setLoading(false); 
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      {loading ? (
        <Loader /> 
      ) : (
        <div className="wrapper w-50 bg-white text-dark rounded shadow-lg p-4">
          <div className="title h2 text-center mb-4">Forgot Password</div>
          {step === 1 ? (
            <form onSubmit={handleEmailSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="off"
                  className="form-control border-dark"
                  placeholder="Enter your email"
                />
              </div>
              <div className="mb-3">
                <input type="submit" value="Send OTP" className="btn btn-dark w-100" />
              </div>
              <div className="signup-link text-center">
                Already have an account? <Link to="/login" className="text-dark">Login</Link>
              </div>
            </form>
          ) : (
            <form onSubmit={handleOtpSubmit}>
              <div className="mb-3">
                <label htmlFor="otp" className="form-label">OTP</label>
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                  autoComplete="off"
                  className="form-control border-dark"
                  placeholder="Enter OTP"
                />
              </div>
              <div className="mb-3 position-relative">
                <label htmlFor="newPassword" className="form-label">New Password</label>
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="newPassword"
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  autoComplete="off"
                  className="form-control border-dark"
                  placeholder="Enter new password"
                />
                <span
                  onClick={togglePasswordVisibility}
                  className="position-absolute top-50 end-0 translate-middle-y m-3" 
                >
                  {showPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
                </span>
              </div>
              <div className="mb-3">
                <input type="submit" value="Reset Password" className="btn btn-dark w-100" />
              </div>
              <div className="signup-link text-center">
                Already have an account? <Link to="/login" className="text-dark">Login</Link>
              </div>
            </form>
          )}
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
